import {parseUnits} from '@ethersproject/units';
import {BigNumber} from 'ethers';
import {useCallback, useMemo} from 'react';
import {chainIdToNetworkName} from '../../lib/chains';
import {useGetNetworksQuery} from '../../redux/projects.api';
import {useAllowanceQuery, useApproveMutation} from '../../redux/token-contract.api';
import {TERC20Token} from '../../redux/types';
import {selectWallet} from '../../redux/wallet.slice';
import {useAppSelector} from '../hooks';

const useApprove = (amount: string, token?: Partial<TERC20Token>) => {
  const {address, chainId} = useAppSelector(selectWallet);
  const {data: networks} = useGetNetworksQuery();
  const rootAddress = networks?.find(el => el.symbol === chainIdToNetworkName[chainId])?.gftRootAddress;
  const {data: allowance, refetch} = useAllowanceQuery([token?.address || '', address, rootAddress || ''], {
    skip: !token || !networks,
  });
  const formattedAmount = useMemo(() => parseUnits(amount || '0', token?.decimals), [amount, token]);
  console.log('allowance', amount, formattedAmount);
  const isApproved = useMemo(() => {
    return !!allowance && allowance.gte(formattedAmount);
  }, [allowance, formattedAmount]);

  const [approveTx] = useApproveMutation();

  const approve = useCallback(async () => {
    if (rootAddress) {
      await approveTx([token?.address || '', rootAddress, BigNumber.from(2).pow(256).sub(1)]);
      return refetch();
    }
  }, [approveTx, refetch, rootAddress, token?.address]);
  return {
    isApproved,
    allowance,
    approve,
    refetchAllowance: refetch,
  };
};

export default useApprove;
